let lenis = null;

export const setLenis = (instance) => {
  lenis = instance;
};

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return false;
  if (lenis) {
    lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
  return true;
};
